import PropTypes from 'prop-types';
import React from 'react';

const AssignIcon = ({ size, style }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      style={style}
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M3 12h12" />
      <path d="M11 8l4 4l-4 4" />
      <path d="M12 21a9 9 0 0 0 0 -18" />
    </svg>
  );
};

AssignIcon.propTypes = {
  size: PropTypes.number,
  style: PropTypes.objectOf(PropTypes.any),
};

AssignIcon.defaultProps = {
  size: 15,
  style: {},
};

export default AssignIcon;
